function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#modify_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 13,
  r: 12,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 13,
  r: 11,
  stroke: "#fff",
  strokeWidth: 2
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.65 9.075l-6.638 6.639-.144 1.58a.587.587 0 00.637.638l1.581-.143 6.64-6.64-2.075-2.074zM18.14 10.735l1.245-1.245c.23-.23.23-.6 0-.83L18.14 7.415a.587.587 0 00-.83 0L16.066 8.66l2.074 2.075z",
  fill: "#5A5A5A"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "modify_svg__filter0_d",
  x: 0,
  y: 0,
  width: 30,
  height: 30,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgModify = function SvgModify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgModify;